export type AssistantComposerKey = {
  isComposing: boolean;
  key: string;
  shiftKey: boolean;
};

export function shouldSubmitAssistantComposer(event: AssistantComposerKey) {
  return !event.isComposing
    && !event.shiftKey
    && (event.key === "Enter" || event.key === "NumpadEnter");
}
